import 'whatwg-fetch';
import './style.scss';
import app from './container/App';

app();
